import "../../data/configuration/state/index2.js";
import "@ado/base-service";
import { createKnownQueryParametersProvider as i } from "../known_query_parameters/index.js";
import "../../data/csr/state/index2.js";
import "../../data/layout/state/index.js";
import "../../data/location/state/index.js";
import "@ado/location-library";
import "../../data/navigation/state/index2.js";
import "@ado/experiment-library";
import "../../../search/state/index2.js";
import { getUser as o } from "../../data/user/state/index2.js";
import "@ado/acs-standard-library";
class v {
  constructor(t = i()) {
    this.knownQueryParametersProvider = t;
  }
  options = {};
  setSecureId() {
    return this.options.secureId = o().secureId, this;
  }
  setKnownQueryParameters(...t) {
    const r = this.knownQueryParametersProvider.provideParameters(
      ...t
    );
    return this.setAdditionalQueryParameters(r), this;
  }
  setMode(t) {
    return this.options.mode = t, this;
  }
  setOrigin(t) {
    return this.options.origin = t, this;
  }
  setAdditionalQueryParameters(t) {
    this.options.data ??= {};
    const r = this.options.data;
    return Object.keys(t).forEach((e) => {
      t[e] !== void 0 && (r[e] = t[e]);
    }), this;
  }
  build() {
    return this.options;
  }
}
export {
  v as DefaultRequestOptionsBuilder
};
//# sourceMappingURL=index2.js.map
